import { routes } from "@constants/routes";
import { Link } from "react-router-dom";

const ForgotPasswordLink = () => {
  return (
    <div className="flex justify-end">
      <Link to={routes.auth.forgetPassword.main} className="text-sm text-primary-700">
        Forget password?
      </Link>
    </div>
  );
};

export default ForgotPasswordLink;
